import type { ParsedTokenInfo } from "./lpTypes";

export function isOwnedNft(info: ParsedTokenInfo, walletAddress: string): boolean {
    return info.owner === walletAddress && info.tokenAmount.amount === "1" && info.tokenAmount.decimals === 0;
}
